import { PriceSettingsField } from '../../../Utilities/Enums/ParametersEnum';
import { CurrencyEnum } from '../../../Utilities/Enums/CurrencyEnums';

export class PriceSetting {
    [PriceSettingsField.MODULES]?: ModulePrice[] = [new ModulePrice()];
    [PriceSettingsField.USER_TIERS]?: UserTier[] = [new UserTier()];
    [PriceSettingsField.STORAGES]?: Storage[] = [new Storage()];
    [PriceSettingsField.ANNUAL_BILLING_DISCOUNT]?: number = 0;
    [PriceSettingsField.CURRENCY_CODE]?: CurrencyEnum = CurrencyEnum.PHP;

    constructor(obj?: Partial<PriceSetting>) {
        Object.assign(this, obj);
    }
}

export class ModulePrice {
    [PriceSettingsField.MODULE_PUBLIC_ID]?: string | number = "";
    [PriceSettingsField.MODULE_NAME]?: string = "";
    [PriceSettingsField.MODULE_BASE_PRICE]?: number = 0;
    [PriceSettingsField.MODULE_BASE_PRICE_CURRENCY_CODE]?: CurrencyEnum = CurrencyEnum.PHP;
    [PriceSettingsField.MODULE_DESCRIPTION]?: string = "";
    tempId?: number = 1;

    constructor(obj?: Partial<ModulePrice>) {
        Object.assign(this, obj);
    }
}

export class UserTier {
    [PriceSettingsField.MIN_USERS]?: number = 1;
    [PriceSettingsField.MAX_USERS]?: number = 0;
    [PriceSettingsField.USERDISCOUNT]?: number = 0;
    tempId?: number = 1;

    constructor(obj?: Partial<UserTier>) {
        Object.assign(this, obj);
    }
}

export class Storage {
    [PriceSettingsField.STORAGE]?: number = 0;
    [PriceSettingsField.STORAGE_PRICE]?: number = 0;
    [PriceSettingsField.STORAGE_DESCRIPTION]?: string = "";
    tempId?: number = 1;

    constructor(obj?: Partial<Storage>) {
        Object.assign(this, obj);
    }
}

export class PriceSettingsInterface {
    formData?: PriceSetting;
    setformData?: React.Dispatch<React.SetStateAction<PriceSetting>>;
    errorMessages?: any;
    setopenDelete?: React.Dispatch<React.SetStateAction<boolean>>;
    settoDeleteItem?: React.Dispatch<React.SetStateAction<any>>;
    setdeleteType?: React.Dispatch<React.SetStateAction<any>>;
    moduleTempId?: number;
    setmoduleTempId?: React.Dispatch<React.SetStateAction<number>>;
    userTierTempId?: number;
    setuserTierTempId?: React.Dispatch<React.SetStateAction<number>>;
    storageTempId?: number;
    setstorageTempId?: React.Dispatch<React.SetStateAction<number>>;
    modulesCount?: number | any;
    setmodulesCount?: React.Dispatch<React.SetStateAction<number>>;
    userTierCount?: number | any;
    setuserTierCount?: React.Dispatch<React.SetStateAction<number>>;
    storageCount?: number | any;
    setstorageCount?: React.Dispatch<React.SetStateAction<number>>;
    priceSettingsTab?: any;
    selectedPriceSettingsTab?: any;

    constructor(obj?: Partial<PriceSettingsInterface>) {
        Object.assign(this, obj);
    }
}